<template>
    <li>
        <template v-if="node.url">
            <small v-if="canEdit" @click="toggleMode" class="node-id">
                <a href="#" @dragstart="dragStartNode" @dragover.prevent @drop="dropNode"
            >[{{node.id}}]</a></small>
            <span>{{node.head}}</span>
            <a :href="node.url" :target="node.target">{{node.title}}</a>
            <!-- $$$ TODO: VALIDATE 'descr' content! -->
            <span v-html="node.descr">{{node.descr}}</span>

            <template v-if="mode==='edit'">
                <div class="row link-form" style="padding-top: 0.8em;">
                    <div class="five columns"><span @click="newLinkNode" class="button button-blue">&nbsp;&nbsp;Neuer Link&nbsp;&nbsp;</span></div>
                    <div class="seven columns "><span @click="deleteNode" class="button button-red u-max-full-width">Löschen</span></div>
                </div>
                <div class="row link-form">
                    <div class="five columns">
                        <span @click="cutNode" class="button button-yellow">Ausschneiden</span>
                    </div>
                    <div class="seven columns ">
                        &nbsp;<!-- <span @click="pasteNode" class="button button-yellow">Einfügen</span> -->
                    </div>
                </div>
                <div class="row link-form">
                    <div class="five columns"><label>Head:</label></div>
                    <div class="seven columns"><input type="text" v-model="node.head"></div>
                </div>
                <div class="row link-form">
                    <div class="five columns"><label>URL:</label></div>
                    <div class="seven columns"><input type="text" v-model="node.url" class=""></div>
                </div>
                <div class="row link-form">
                    <div class="five columns"><label>Url-Target:</label></div>
                    <div class="seven columns"><input type="text" v-model="node.target"></div>
                </div>
                <div class="row link-form">
                    <div class="five columns"><label>Url-Title:</label></div>
                    <div class="seven columns"><input type="text" v-model="node.title"></div>
                </div>
                <div class="row link-form">
                    <div class="five columns"><label>Descr:</label></div>
                    <div class="seven columns"><input type="text" v-model="node.descr"></div>
                </div>
                <div class="row link-form" style="border-bottom-left-radius: 6px; border-bottom-right-radius: 6px;">
                    <div class="five columns"><div class="button button-primary" @click="saveNode">Speichern</div></div>
                    <div class="seven columns"><span class="button" @click="cancelNode">Abbrechen</span></div>
                </div>
            </template>

        </template>
        <template v-else>
            <div class="node-group">
                <small v-if="canEdit" @click="toggleMode" class="node-id">
                    <a href="#" @dragstart="dragStartNode" @dragover.prevent @drop="dropNode">[{{node.id}}]</a></small>
                <b @click="toggleExpanded">{{node.title}}</b>

                <template v-if="mode==='edit'">
                    <div class="row link-form" style="padding-top: 0.8em;">
                        <div class="five columns">
                            <span @click="newGroupNode" class="button button-blue">Neue Gruppe</span>
                            <span @click="newLinkNode" class="button button-blue">Neuer Link</span>
                        </div>
                        <div class="seven columns "><span @click="deleteNode" class="button button-red u-max-full-width">Löschen</span></div>
                    </div>

                    <div class="row link-form">
                        <div class="five columns">
                            <span @click="cutNode" class="button button-yellow">Ausschneiden</span>
                        </div>
                        <div class="seven columns ">
                            <span @click="pasteNode" class="button button-yellow">Einfügen</span>
                        </div>
                    </div>

                    <div class="row link-form">
                        <div class="five columns"><label>Title:</label></div>
                        <div class="seven columns"><input type="text" v-model="node.title"></div>
                    </div>
                    <div class="row link-form" style="border-bottom-left-radius: 6px; border-bottom-right-radius: 6px;">
                        <div class="five columns"><div class="button button-primary" @click="saveNode">Speichern</div></div>
                        <div class="seven columns"><span class="button" @click="cancelNode">Abbrechen</span></div>
                    </div>
                </template>

            </div>
            <ul v-if="node.children && node.children.length" v-show="isExpanded">
                <!-- v-bind:key="childNode.id" -->
                <link-tree-node
                    v-for="(childNode, index) in node.children"
                    v-bind:key="index"
                    :node='childNode'
                    :can-edit="canEdit"></link-tree-node>
            </ul>
        </template>
    </li>
</template>

<script>
export default {
    name: 'LinkTreeNode',
    props: [ 'node', 'can-edit' ],
    mounted () {
        this.$on('update-link-node', this.onUpdateLinkNode)
        // console.log('LinkTreeNode.mounted: $on "update-link-node" registerd.')
        this.$on('onAddChild', this.onAddChild)
        this.$on('onCutChildNode', this.onCutChildNode)
        this.$on('onDragStart', this.onDragStart)
        this.$on('onDropNode', this.onDropNode)
    },
    data: function () {
        return {
            isExpanded: false,
            mode: 'show', // 'edit' | 'show'
            crudMode: '' // 'update' | 'create' |'delete' | 'cut' | 'paste' | 'dragStart' | 'drop'
        }
    },
    methods: {
        toggleExpanded: function () {
            this.isExpanded = !this.isExpanded
        },
        toggleMode: function () {
            console.log('toggleMode')
            // Set mode='show' for all siblings
            if (this.mode === 'edit') {
                this.mode = 'show'
            } else {
                this.mode = 'edit'
            }
        },
        /* ***
        dragNode: function () {
            // console.log(`LinkTreeNode.dragNode: this.node.(id/title): -- !! NOT IMPLEMENTED !! --
            // ${this.node.id} / ${this.node.title}`)
        },
        dragEnterNode: function () {
            // console.log(`LinkTreeNode.dragEnterNode: this.node.(id/title): -- !! NOT IMPLEMENTED !! --
            // ${this.node.id} / ${this.node.title}`)
        },
        dragLeaveNode: function () {
            // console.log(`LinkTreeNode.dragLeaveNode: this.node.(id/title): -- !! NOT IMPLEMENTED !! --
            // ${this.node.id} / ${this.node.title}`)
        },
        dragEndNode: function () {
            // console.log(`LinkTreeNode.dragEndNode: this.node.(id/title): -- !! NOT IMPLEMENTED !! --
            // ${this.node.id} / ${this.node.title}`)
        },
        dragOverNode: function () {
            // console.log(`LinkTreeNode.dragOverNode: this.node.(id/title): -- !! NOT IMPLEMENTED !! --
            // ${this.node.id} / ${this.node.title}`)
        }, *** */
        dragStartNode: function () {
            // console.log(`LinkTreeNode.dragStartNode: this.node.(id/title):
            // ${this.node.id} / ${this.node.title}`)

            this.$parent.$emit('onDragStart', this.node, null)
            this.mode = 'show'
        },
        dropNode: function () {
            // console.log(`LinkTreeNode.dropNode: this.node.(id/title):
            // ${this.node.id} / ${this.node.title}`)

            this.$parent.$emit('onDropNode', this.node, null)
            this.mode = 'show'
        },
        onDragStart: function (dragedNode, dragedParent) {
            // console.log(`LinkTreeNode.onDragStart:
            // dragedNode.(id/title)  : ${dragedNode.id} / ${dragedNode.title}
            // dragedParent.(id/title): ${dragedParent ? dragedParent.id : 'null'} / ${dragedParent ? dragedParent.title : 'null'}`)

            if (dragedParent === null) {
                // $$$ check if this.node is direkt parent of dragedNode
                dragedParent = this.node
            }
            this.$parent.$emit('onDragStart', dragedNode, dragedParent)
        },
        onDropNode: function (dropNode, dropParent) {
            console.log(`LinkTreeNode.onDropNode:
            dropNode.(id/title)  : ${dropNode.id} / ${dropNode.title}
            dropParent.(id/title): ${dropParent ? dropParent.id : 'null'} / ${dropParent ? dropParent.title : 'null'}`)

            if (dropParent === null) {
                // $$$ check if this.node is direct parent of dropNode
                dropParent = this.node
            }
            this.$parent.$emit('onDropNode', dropNode, dropParent)
        },
        // *** CRUD node operations ***
        cancelNode: function () {
            this.mode = 'show'
        },
        saveNode: function () {
            console.log('LinkTreeNode.saveNode: this.node.(id/title): ' + this.node.id + ' / ' + this.node.title)
            this.crudMode = 'update'
            this.$parent.$emit('update-link-node', this.crudMode, this.node, this.node)
            this.mode = 'show'
        },
        newLinkNode: function () {
            console.log(`LinkTreeNode.newLinkNode:
            this.node.(id/title): ${this.node.id} / ${this.node.title}
            has children: ${(this.node.children && this.node.children.length)}`)

            if (this.node.children && this.node.children.length >= 0) {
                this.$emit('onAddChild', false)
            } else {
                this.$parent.$emit('onAddChild', false)
            }
            this.mode = 'show'
        },
        newGroupNode: function () {
            console.log(`LinkTreeNode.newGroupNode:
            this.node.(id/title): ${this.node.id} / ${this.node.title}`)

            this.$emit('onAddChild', true)
            this.mode = 'show'
        },
        onAddChild: function (isGroup) {
            console.log(`LinkTreeNode.onAddChild: isGroup: ${!!isGroup}
            this.node.(id/title): ${this.node.id} / ${this.node.title}`)
            // console.log('this.node: '); console.dir(this.node)

            let newNode = {}
            if (isGroup) {
                newNode.id = 0
                newNode.title = 'Neue Gruppe'
                newNode.children = []
            } else {
                newNode.id = 0
                newNode.title = 'Neuer Link'
                newNode.url = '#'
            }
            this.node.children.push(newNode)
            this.crudMode = 'create'
            this.$parent.$emit('update-link-node', this.crudMode, newNode, newNode)
        },
        deleteNode: function () {
            console.log(`LinkTreeNode.deleteNode:  -- $$$ TODO: NOT IMPLEMENTED!!! --
            this.node.(id/title): ${this.node.id} / ${this.node.title}`)
            // $$$
            this.crudMode = 'delete'
            this.mode = 'show'
        },
        cutNode: function () {
            console.log(`LinkTreeNode.cutNode:
            this.node.(id/title): ${this.node.id} / ${this.node.title}`)

            this.$parent.$emit('onCutChildNode', this.node)
            this.mode = 'show'
        },
        onCutChildNode: function (cutedNode) {
            console.log(`LinkTreeNode.onCutChildNode:
            cutedNode.(id/title): ${cutedNode.id} / ${cutedNode.title}`)

            let cutedNodeIndex = this.node.children.findIndex(element => { return element.id === cutedNode.id })
            if (cutedNodeIndex >= 0) {
                this.node.children.splice(cutedNodeIndex, 1)
                this.crudMode = 'cut'
                this.$parent.$emit('update-link-node', this.crudMode, cutedNode, this.node)
            }
        },
        pasteNode: function () {
            console.log(`LinkTreeNode.pasteNode:
            this.node.(id/title): ${this.node.id} / ${this.node.title}`)

            if (this.node.children && this.node.children.length >= 0) {
                this.crudMode = 'paste'
                this.$parent.$emit('update-link-node', this.crudMode, this.node, this.node)
                this.mode = 'show'
            }
        },
        // *** Event-Bus handler ***
        onUpdateLinkNode: function (crudMode, node, parent) {
            console.log(`LinkTreeNode.onUpdateLinkNode
            CRUD-mode   : ${crudMode}
            Reciever: id: ${this.node.id} - title: ${this.node.title}
            node:     id: ${node.id || null} - title: ${node.title || null}
            parent:   id: ${parent.id || null} - title: ${parent.title || null}
            $emit to $parent...`)
            // Recurse upward
            this.$parent.$emit('update-link-node', crudMode, node, parent)
        }
    }
}
</script>

<style scoped>
    li {
        font-size: 10.5pt;
        list-style-type:none;

    }
    .node-id {
        color: #fcaa58;
        margin-right: 4px;
        cursor: pointer;
    }
    .node-group {
        padding-top: 4px;
        padding-bottom: 4px;
        margin-left: -1em; padding-left: 1em;
        /* border: 1px solid #ff006030; */
        border-left: 1px solid #c0c0c070; border-top: 1px solid #c0c0c070; border-right: 1px solid silver; border-bottom: 1px solid silver;
        border-radius: 4px;
        background-color: #ffffff00; /* wheat; */
        cursor: pointer;
    }
    .expander {
        display:inline-block;
        width: 1em;
        margin-left: 5px;
        margin-right: 4px;
        padding: 0px 4px 2px 4px;
        border: 1px solid #e0e0e0;
        border-radius: 3px;
        text-align: center;
        background-color: #f0f0f0;
        cursor: pointer;
    }

    .link-form {
        margin-right:12px;
        background-color: #e0e0e0;
        padding-left: 2em;
        color: #303030;
    }
    /* label {
        padding-left: 2em;
    } */
    input {
        /* margin-left: 2em; */
        /* margin-right: 12px; */
        width: 92%;
    }
    .button {
        letter-spacing: .15rem;
        /* background-color: white; */
        /* SEE:   https://www.w3schools.com/colors/colors_gradient.asp */
        background: -webkit-linear-gradient(top, #ffffff 31%, #e8e8e8 59%);
        background: linear-gradient(to bottom, #ffffff 31%, #e8e8e8 59%);
        text-transform:none;
        font-size:1.03em;
        font-weight:600;
    }
    .button-primary {
        background-color: #009000;
        background: -webkit-linear-gradient(top, #66ff66 0%, #009900 59%);
        background: linear-gradient(to bottom, #66ff66 0%, #009900 59%);
        border: 1px solid #009900;
        /*
        letter-spacing: .15rem;
        border-radius: 4px;
        text-transform:none;
        font-size:1.03em;
        */
        font-weight:700;
    }
    .button-primary:hover {
        letter-spacing: .15rem;
        border: 1px solid darkgreen;
        background-color: #009000;
        text-shadow: -1.5px 0.5px 0.8px darkgreen;
        text-transform:none;
        font-size:1.03em;
        font-weight:700;
    }
    .button-blue {
        background-color: #0000ff;
        background: -webkit-linear-gradient(top, #9999ff 0% ,#0000ff 59%); /* Chrome10-25,Safari5.1-6 */
        background: linear-gradient(to bottom,   #9999ff 0%, #0000ff 59%);
        border: 1px solid #3333b0;
        color: #fff;
    }
    .button-blue:hover {
        text-shadow: -1.5px 0.5px 0.8px #6666ff;
        border: 1px solid #000060;
    }
    .button-red {
        background-color: #bf0000;
        background: -webkit-linear-gradient(top, #ff8888 0% ,#bf0000 59%); /* Chrome10-25,Safari5.1-6 */
        background: linear-gradient(to bottom, #ff8888 0%, #bf0000 59%);
        border: 1px solid #990000;
        color: #fff;
    }
    .button-red:hover {
        border: 1px solid #780000;
        text-shadow: -1.5px 0.5px 0.8px #800000;
    }
    .button-yellow {
        background-color: #bf9000;
        background: -webkit-linear-gradient(top, #ffcc88 0% ,#bf9000 59%); /* Chrome10-25,Safari5.1-6 */
        background: linear-gradient(to bottom, #ffcc88 0%, #bf9000 59%);
        border: 1px solid #997000;
        color: #fff;
    }
    .button-yellow:hover {
        border: 1px solid #785000;
        text-shadow: -1.5px 0.5px 0.8px #806000;
    }
</style>



// WEBPACK FOOTER //
// src/components/LinkTreeNode.vue